/**
 * Base shape every localized root object receives when delivered through
 * `wpLocalizeScriptResources`. The generic parameter lets consumers intersect
 * their plugin-specific fields.
 */ /**
 * Ensure `fetch()` exists on a localized root object and return it typed.
 *
 * Pass in whatever you already resolved from `window` (e.g. via
 * `getAnonymousLocalizedScript`). Does not look up `window` itself.
 */ function withLocalizedResourceFetch(object) {
    const root = object;
    if (typeof root.fetch !== "function") {
        root.fetch = async ()=>root;
    }
    return root;
}
export { withLocalizedResourceFetch };
